<template>
  <base-show :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template v-slot:actions.remove>
      <span v-if="authAccountId === pk" />
    </template>
  </base-show>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;
    return {
      resourceName: "questionnaires",
      fields: [
        [
          {
            label: "アンケート名",
            name: "form_title",
            long: true
          },
          {
            label: "アンケートページURL",
            name: "url",
            long: true
          },
          {
            label: "公開期間 from",
            name: "publish_from",
            long: true
          },
          {
            label: "公開期間 to",
            name: "publish_to",
            long: true
          },
          {
            label: "概要",
            name: "description",
            long: true
          },
          {
            label: "公開/非公開",
            name: "publish",
            optionType: "common/publish",
            render(value) {
              return vm.optionName("common/publish", value);
            }
          }
        ]
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "アンケート一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "アンケート詳細",
          disabled: true
        }
      ];
    },
    authAccountId() {
      return this.$store.getters[`auth/accountId`];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    }
  }
};
</script>
